if (!customElements.get("why-atp-steps")) {
  customElements.define(
    "why-atp-steps",
    class WhyAtpSteps extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.navSteps = this.querySelector("#StepsNav");
        this.navSteps_Steps =
          this.navSteps.querySelectorAll(".steps-nav__item");

        this.navSteps_Steps.forEach((step) => {
          step.addEventListener("click", this.handleStepNavClick);
        });

        this.currentScrollTop = 0;
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener("scroll", this.onScrollHandler, false);
      }

      disconnectedCallback() {
        window.removeEventListener("scroll", this.onScrollHandler);
      }

      handleStepNavClick = ({ currentTarget }) => {
        let navStep;
        let stepBlock;

        currentTarget.classList.contains(".nav-step")
          ? (navStep = currentTarget)
          : (navStep = currentTarget.closest(".nav-step"));

        stepBlock = this.querySelector(`#${navStep.dataset.stepTarget}`);

        if (stepBlock) this.scrollToStep(stepBlock);
      };

      scrollToStep(target) {
        this.navSteps_Steps.forEach((step) => {
          if (step.dataset.stepTarget === target.id) {
            step.classList.add("is-selected");
          } else {
            step.classList.remove("is-selected");
          }
        });

        var targetBounds = target.getBoundingClientRect(),
          scrollTop = targetBounds.top - 185;

        window.scrollBy({
          top: scrollTop,
          behavior: "smooth",
        });
      }

      onScroll() {
        if (window.matchMedia("(max-width: 860px)").matches) return;

        const header = document.getElementById("header");
        const targetBounds = this.getBoundingClientRect();
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > this.currentScrollTop && scrollTop > 279) {
          requestAnimationFrame(this.modifyNavSteps.bind(this));
        } else if (scrollTop <= 279) {
          requestAnimationFrame(this.resetNavSteps.bind(this));
        }

        this.currentScrollTop = scrollTop;

        if (targetBounds.bottom <= window.innerHeight) {
          this.navSteps.classList.add("stop-sticky");
          this.navSteps.style.cssText += `--fixed-top: ${
            targetBounds.height - window.innerHeight + header.offsetHeight
          }px`;

          return;
        }

        this.navSteps.classList.remove("stop-sticky");
        if (window.pageYOffset > 260) {
          this.navSteps.style.cssText += `--fixed-top: ${header.offsetHeight}px`;
        }
      }

      modifyNavSteps() {
        if (!this.navSteps.classList.contains("steps-nav--sticky")) {
          this.navSteps.classList.add("steps-nav--sticky", "hidden");
          this.style.marginTop = 305 + "px";
          setTimeout(() => {
            this.navSteps.classList.add("animate");
            this.navSteps.classList.remove("hidden");
          }, 150);
        }
      }

      resetNavSteps() {
        this.navSteps.classList.remove("steps-nav--sticky", "animate");
        this.style.marginTop = "";
      }
    }
  );
}